import { render, staticRenderFns } from "./UpdateCourseCategoryDialog.vue?vue&type=template&id=753ffa2e"
import script from "./UpdateCourseCategoryDialog.vue?vue&type=script&lang=js"
export * from "./UpdateCourseCategoryDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateCourseCategoryDialog.vue?vue&type=style&index=0&id=753ffa2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports